export interface ReciboAdicionales {
  mesaDulce?: number
  posCena?: number
  barra?: number
}

export const obtenerAdicionalesRecibo = (recibo: ReciboAdicionales) =>
  [
    { label: "Mesa dulce", cantidad: recibo.mesaDulce ?? 0 },
    { label: "Pos cena", cantidad: recibo.posCena ?? 0 },
    { label: "Barra", cantidad: recibo.barra ?? 0 },
  ].filter((adicional) => adicional.cantidad > 0)
